import styled from 'styled-components';

export const SDMContactFormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FieldWrapper = styled.div`
  margin-top: 8px;
`;

export const ButtonWrapper = styled.div`
  margin-top: 16px;
`;

export const SelectWrapper = styled.div`
  select {
    border: solid 1px #ccc;
    width: 100%;
    height: 55px;
    padding-left: 28px;
    padding-right: 30px;
    margin: 0;
    margin-top: 5px;
  }
`;
